import { Insurer, Language, ServiceAvailable, Country } from "../../core/interfaces/doctor.interface";

export interface ReferentielState {
  languages: Language[] | null;
  services: ServiceAvailable[] | null;
  insurers: Insurer[] | null;
  countries: Country[] | null;
  loading: boolean;
  error: string | null;
}

export const initialReferentielState: ReferentielState = {
  languages: null,
  services: null,
  insurers: null,
  countries: null,
  loading: false,
  error: null,
};
